import { render } from "./DinkesComponent.vue?vue&type=template&id=6a33e90c"
import script from "./DinkesComponent.vue?vue&type=script&lang=js"
export * from "./DinkesComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__